var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Box, Button, createFilterOptions, Divider, TextField, } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useListOpponentTeams } from "../api/MatchApiProvider";
import { useRetrievePlayersByTeamId } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { TeamChooser } from "./TeamChooser";
export var ExternalMatchForm = function (_a) {
    var _b, _c;
    var team = _a.team, onSubmit = _a.onSubmit, externalMatch = _a.externalMatch;
    var useFormProps = useForm({
        defaultValues: {
            kickOff: externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.kickOff,
            players: ((_b = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.players) === null || _b === void 0 ? void 0 : _b.map(function (p) { return Number(p); })) || [],
            opponentTeamId: (_c = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.opponentTeam) === null || _c === void 0 ? void 0 : _c.id,
            opponentTeamName: undefined,
            team: team.id,
        },
    });
    var control = useFormProps.control, handleSubmit = useFormProps.handleSubmit, errors = useFormProps.formState.errors, setValue = useFormProps.setValue;
    var _d = useRetrievePlayersByTeamId({ teamId: team.id }), players = _d.data, playersError = _d.error, playersIsLoading = _d.isLoading;
    var _e = useListOpponentTeams(), opponentTeams = _e.data, opponentTeamsIsLoading = _e.isLoading, opponentTeamsError = _e.error;
    var _f = __read(React.useState({
        teams: [],
        bench: [],
    }), 2), teamSelection = _f[0], _setTeamSelection = _f[1];
    var setTeamSelection = function (newSelection) {
        _setTeamSelection(newSelection);
        var _a = __read(newSelection.teams, 1), selectedTeam = _a[0];
        setValue("players", selectedTeam.players.map(function (p) { return p.id; }));
    };
    var _g = __read(React.useState((externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.opponentTeam)
        ? {
            opponentTeamId: externalMatch.opponentTeam.id,
            opponentTeamName: externalMatch.opponentTeam.name,
        }
        : null), 2), selectedOpponentTeam = _g[0], setSelectedOpponentTeam = _g[1];
    useEffect(function () {
        var _a = selectedOpponentTeam || {}, opponentTeamId = _a.opponentTeamId, opponentTeamName = _a.opponentTeamName;
        if (opponentTeamId) {
            setValue("opponentTeamId", opponentTeamId);
            setValue("opponentTeamName", null);
        }
        else {
            setValue("opponentTeamId", null);
            setValue("opponentTeamName", opponentTeamName);
        }
    }, [selectedOpponentTeam]);
    React.useEffect(function () {
        var _a;
        if (!players)
            return;
        var getPlayerById = function (id) { return players.find(function (p) { return p.id === id; }); };
        setTeamSelection({
            teams: [
                {
                    name: "Team",
                    players: ((_a = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.players) === null || _a === void 0 ? void 0 : _a.map(getPlayerById).filter(function (p) { return !!p; })) || [],
                    primaryColour: undefined,
                },
            ],
            bench: players.filter(function (p) { var _a; return !((_a = externalMatch === null || externalMatch === void 0 ? void 0 : externalMatch.players) === null || _a === void 0 ? void 0 : _a.includes(p.id)); }) || [],
        });
    }, [players, externalMatch]);
    var isLoading = playersIsLoading || opponentTeamsIsLoading;
    var filter = createFilterOptions();
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (!team || !opponentTeams || !players) {
        return (_jsx(ErrorView, { error: new Error("Team, opponent teams or players not found") }));
    }
    if (opponentTeamsError || playersError) {
        return _jsx(ErrorView, { error: opponentTeamsError || playersError });
    }
    return (_jsx(FormProvider, __assign({}, useFormProps, { children: _jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, sx: { mt: 1 }, children: [_jsx(Autocomplete, { fullWidth: true, value: selectedOpponentTeam, onChange: function (event, newValue) {
                        if (typeof newValue === "string") {
                            setSelectedOpponentTeam({
                                opponentTeamName: newValue,
                                opponentTeamId: null,
                            });
                        }
                        else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setSelectedOpponentTeam({
                                opponentTeamName: newValue.inputValue,
                                opponentTeamId: null,
                            });
                        }
                        else {
                            setSelectedOpponentTeam(newValue);
                        }
                    }, filterOptions: function (options, params) {
                        var filtered = filter(options, params);
                        var inputValue = params.inputValue;
                        var isExisting = options.some(function (option) { return inputValue === option.opponentTeamName; });
                        if (inputValue !== "" && !isExisting) {
                            filtered.push({
                                inputValue: inputValue,
                                opponentTeamName: "Add \"".concat(inputValue, "\""),
                            });
                        }
                        return filtered;
                    }, selectOnFocus: true, clearOnBlur: true, handleHomeEndKeys: true, id: "free-solo-with-text-demo", options: (opponentTeams.map(function (opponentTeam) {
                        return {
                            opponentTeamId: opponentTeam.id,
                            opponentTeamName: opponentTeam.name,
                        };
                    }) || []), getOptionLabel: function (option) {
                        if (typeof option === "string") {
                            return option;
                        }
                        if (option.inputValue) {
                            return option.inputValue;
                        }
                        return option.opponentTeamName;
                    }, renderOption: function (props, option) {
                        return _jsx("li", __assign({}, props, { children: option.opponentTeamName }));
                    }, freeSolo: true, renderInput: function (params) {
                        var _a, _b;
                        return (_jsx(TextField, __assign({}, params, { margin: "normal", fullWidth: true, label: "Opponent Team", required: true, error: !!errors.opponentTeamId || !!errors.opponentTeamName, helperText: ((_a = errors.opponentTeamId) === null || _a === void 0 ? void 0 : _a.message) ||
                                ((_b = errors.opponentTeamName) === null || _b === void 0 ? void 0 : _b.message), autoFocus: true })));
                    } }), _jsx(Controller, { name: "kickOff", control: control, rules: { required: "Kick-Off is required" }, render: function (_a) {
                        var field = _a.field;
                        return (_jsx(DateTimePicker, __assign({ label: "Kick-Off" }, field, { value: field.value ? dayjs(field.value) : null, onChange: function (newValue) { return field.onChange(newValue); }, sx: { width: "100%", mt: 2 }, slotProps: {
                                textField: {
                                    error: !!errors.kickOff,
                                    helperText: errors.kickOff ? errors.kickOff.message : "",
                                },
                            } })));
                    } }), _jsx(Divider, { sx: {
                        margin: "20px",
                    } }), _jsx(TeamChooser, { teamSelection: teamSelection, setTeamSelection: setTeamSelection, canEditTeamNames: false, maxTeams: 1, minTeams: 1 }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, children: externalMatch === undefined ? "Create" : "Update" })] }) })));
};
